import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import analytics from '../../helpers/analytics'
import {SlideDown} from 'react-slidedown'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  AmazonCompanyLetter
} from '../../components'
import Styles from './AmazonStaffLanding.css'


@CSSModules(Styles, {allowMultiple:true})
export default class AmazonStaffLanding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const headlineImg = require('../../../static/images/monkeys-circle.jpg')
    const mobileBannerStyle = this.state.mobileBannerFixed ?
      'mobile-fixed' :
      'mobile-relative'

    return (
      <div styleName='page'>
        <ContainerDivs>

          <div styleName='hl-wrap'>
            { /* LEFT COLUMN */ }
            <div>
              <img
                src={headlineImg}
                alt='Save for your future without ruining theirs'
                styleName='hl-img-sm visible-xs'
              />
              <div styleName='hl'>
                Your retirement plan is destroying the Amazon rainforest... but it doesn’t have to.
              </div>
              <div styleName='copy'>
                <p>
                  Amazon offers employees a 401(k) plan that invests over $500 million dollars in fossil fuels, deforestation, and arms manufacturers, among other risky industries. These unsustainable industries threaten the environment <i>and</i> your retirement. Most Amazon employees don’t know their 401(k)s are destroying the Amazon rainforest, but that’s about to change.
                </p>

                <p styleName='scroll-link'>
                  <ScrollLink
                    activeClass='active-scroll-link'
                    to='section1'
                    spy
                    smooth
                    offset={-70}
                    duration={500}
                  >
                    <b>Join <i>As You Sow</i> to urge Amazon management to live up to their public commitments by offering conscientious employees like you a more sustainable default retirement fund.</b>
                  </ScrollLink>
                </p>

                <div styleName='hidden-xs'>
                  <h2 styleName='subtitle'>
                    Amazon 401(k) by the numbers
                  </h2>
                  <ul>
                    <li>
                      <b>52%</b> of plan assets are invested in the default Vanguard Target Retirement Funds series.
                    </li>
                    <li>
                      Plan participants have <b>+$500M</b> flagged by environmental and social risk screens.
                    </li>
                    <li>
                      Only <b>1 / 26</b> plan options report a sustainability mandate.
                    </li>
                  </ul>
                  <h2 styleName='subtitle'>
                    Our letter to company management
                  </h2>
                  { /* PETITION LETTER */ }
                  <AmazonCompanyLetter differentPage/>
                </div>

                { /* AFTER PETITION LINKS */ }
                <div styleName='after-petition-links hidden-xs'>
                  <div styleName='after-petition-links-lbl'>
                    More
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.plans + '/amazon-com'}
                      title='Amazon 401(k) scorecard'
                      xstrong
                    >
                      See the scorecard for the Amazon 401(k)<LinkIcon/>
                    </Link>
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.eduCenter}
                      title='Action center'
                      xstrong
                    >
                      Action center<LinkIcon/>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            { /* RIGHT COLUMN */ }
            <div styleName='hl-img-wrap'>
              <div styleName='petition-widget-wrap'>
                <img
                  src={headlineImg}
                  alt='Save for your future without ruining theirs'
                  styleName='hl-img hidden-xs'
                />
                <div styleName={'sticky-widget ' + mobileBannerStyle}>
                  <div id='section1'/>
                  <div styleName='sticky-widget-close visible-xs'>
                    <div
                      onClick={
                        () => {
                          //
                          this.setState({
                            mobileBannerFixed: false
                          })
                        }
                      }
                    >
                      <LinkIcon nospace faclass='fa-close'/>
                    </div>
                  </div>
                  <h2 styleName='thumbs-up-top-label'>
                    Give us a thumbs up if you want a more sustainable 401(k).
                  </h2>
                  <Link
                    to={config.routes.amazonStaffThanks}
                    title='Count me in'
                    log={analytics.eventStaffSupport('Amazon','count_me_in')}
                    linkedin='4674186'
                    fbPixel
                    id='amazon-staff-support'
                  >
                    <button styleName='thumbs-up-flex wiggle'>
                      <div styleName='thumbs-up-label'>
                        Count me in
                      </div>
                      <div styleName='thumbs-up'>
                        <LinkIcon nospace faclass='fa-thumbs-o-up'/>
                      </div>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div styleName='visible-xs'>
            <div
              styleName='show-more-button'
              title='Learn more'
              onClick={
                (e)=>{
                  this.setState({showFullPetition: !this.state.showFullPetition})
                }
              }
            >
              Learn more<LinkIcon faclass={
                this.state.showFullPetition ?
                  'fa-angle-double-up' :
                  'fa-angle-double-down'
              }/>
            </div>
            <SlideDown>
              {
                this.state.showFullPetition ?
                  (
                    <div styleName='copy'>
                      <h2 styleName='subtitle'>
                        Amazon 401(k) by the numbers
                      </h2>
                      <ul>
                        <li>
                          <b>52%</b> of plan assets are invested in the default Vanguard Target Retirement Funds series.
                        </li>
                        <li>
                          Plan participants have <b>+$500M</b> flagged by environmental and social risk screens.
                        </li>
                        <li>
                          Only <b>1 / 26</b> plan options report a sustainability mandate.
                        </li>
                      </ul>
                      <h2 styleName='subtitle'>
                        Our letter to company management
                      </h2>
                      { /* PETITION LETTER */ }
                      <AmazonCompanyLetter differentPage/>
                    </div>
                  ) :
                  null
              }
            </SlideDown>
          </div>

          { /* AFTER PETITION LINKS */ }
          <div styleName='after-petition-links visible-xs'>
            <div styleName='after-petition-links-lbl'>
              More
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.plans + '/amazon-com'}
                title='Amazon 401(k) scorecard'
                xstrong
              >
                See the scorecard for the Amazon 401(k)<LinkIcon/>
              </Link>
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.eduCenter}
                title='Action center'
                xstrong
              >
                Action center<LinkIcon/>
              </Link>
            </div>
          </div>

        </ContainerDivs>
      </div>
    )
  }
}
